import Reflux from 'reflux';
import intersection from 'lodash/intersection';

import configurationStore from './configuration-store';
import itemFacetStore from './item-facet-store';

export default Reflux.createStore({
	init() {
		this.listenTo(configurationStore, this.onConfigurationChange);
		this.listenTo(itemFacetStore, this.onFacetChange);

		this.state = {
			facets: [],
			isSelected: false,
			configuration: {
				visibleFacets: [],
				preselection: {}
			}
		};
	},

	onConfigurationChange(configuration) {
		this.state.configuration.visibleFacets = configuration.visibleFacets;
		this.state.configuration.preselection = configuration.preselection;
	},

	onFacetChange(data) {
		this.state.facets = data.facets;
		const facet = data.facets[0];
		if (facet && (facet.properties.some(prop => prop.isSelected) || facet.properties.length <= 1)) {
			this.state.isSelected = true;
		}
		this.output();
	},

	getState() {
		const facetIds = intersection(
			this.state.configuration.visibleFacets,
			Object.keys(this.state.configuration.preselection).map(id => parseInt(id, 10))
		);
		let state = Object.assign({}, this.state);
		state.facets = this.state.facets.filter(facet => facetIds.indexOf(facet.id) > -1);
		return state;
	},

	output() {
		this.trigger(this.getState());
	},

	getInitialState() {
		return this.getState();
	}
});
